import Upload from './upload';
export type { UploadFile, RcFile } from './upload.types';
export default Upload;
